<app-bottom-sheet #sheet ariaLabel="عملیات سفارش‌ها">
	<ng-template #body>
		<ul class="flex list-none flex-col divide-y divide-stroke-100 p-0" data-cy="orders-actions-list">
			<li>
				<button
					type="button"
					class="flex w-full cursor-pointer items-center gap-2 py-3 text-right text-3.25 font-medium text-gray-900"
					data-cy="orders-action-bulk-delete"
					(click)="onActionClick('bulk-delete')">
					<ui-icon class="shrink-0 text-gray-600" width="20" height="20" iconName="list-select" />
					<span>حذف گروهی</span>
				</button>
			</li>
			<li>
				<button
					type="button"
					class="flex w-full cursor-pointer items-center gap-2 py-3 text-right text-3.25 font-medium text-gray-900"
					data-cy="orders-action-today-activity"
					(click)="onActionClick('today-activity')">
					<ui-icon class="shrink-0 text-gray-600" width="20" height="20" iconName="activity" />
					<span>فعالیت امروز</span>
				</button>
			</li>
			<li>
				<button
					type="button"
					class="flex w-full cursor-pointer items-center gap-2 py-3 text-right text-3.25 font-medium text-gray-900"
					data-cy="orders-action-settings"
					(click)="onActionClick('settings')">
					<ui-icon class="shrink-0 text-gray-600" width="20" height="20" iconName="setting" />
					<span>تنظیمات ارسال سفارش</span>
				</button>
			</li>
		</ul>
	</ng-template>
</app-bottom-sheet>
